(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name core.factory:ConfigService
   *
   * @description
   *
   */
  angular
    .module('core')
    .provider('ConfigService', ConfigServiceProvider);

  function ConfigServiceProvider($sessionStorageProvider) {
    //TODO: Move all constants that can be configurable here
    var defaultLocale = 'en';
	var serverId = '1';
	var url = 'http://hgaa-api1.hermes.si/HypoMne/'; //dodan novi API za BIH
	var authorizationUrl = 'http://colossus/OAuthServer/oauth/authorize';
	var logoutUrl = 'http://colossus/OAuthServer/oauth/logout';

    return {
      defaultLocale: defaultLocale,
		serverId: serverId,
      $get:function($sessionStorage){
        var ConfigServiceBase = {};
        ConfigServiceBase.addQueryString = function addQueryString(uri, parameters) {
          var delimiter = (uri.indexOf('?') == -1) ? '?' : '&';
          for (var parameterName in parameters) {
            var parameterValue = parameters[parameterName];
            uri += delimiter + encodeURIComponent(parameterName) + '=' + encodeURIComponent(parameterValue);
            delimiter = '&';
          }
          return uri;
        };

        var host = window.location;
        var pathname = location.pathname.substring(0, location.pathname.lastIndexOf("/"));
        var defaultRedirectUrl = host.protocol + '//' + host.host + pathname + '/login.html';

        if($sessionStorage.stateRequest == undefined){
          $sessionStorage.stateRequest = Math.random();
        }

		ConfigServiceBase.disabledEndpoints = ["eInvoiceDocuments"];
		ConfigServiceBase.defaultLocale = defaultLocale; //Dejan: Dodao sam defaultLocale jer je bio undefined
		ConfigServiceBase.serverId = serverId;
        ConfigServiceBase.url = url;
        //ConfigServiceBase.clientId = '7890ab'; //TODO: Change this to real clientId
        ConfigServiceBase.clientId = 'MneSit'; //TODO: Change this to real clientId
        ConfigServiceBase.defaultRedirectUrl = defaultRedirectUrl;//'http://localhost/Comtrade.Banking.WebAPI/Areas/Swagger/o2c.html'//defaultRedirectUrl;
        ConfigServiceBase.authorizationUrl = ConfigServiceBase.addQueryString(authorizationUrl, {
          'client_id': ConfigServiceBase.clientId,
          'redirect_uri': ConfigServiceBase.defaultRedirectUrl,
          'state':  $sessionStorage.stateRequest,
          'scope': 'OSEB_SM',
          'login_hint':'username_password_sms_otp',
          'response_type': 'token'
        });
        ConfigServiceBase.logoutUrl = ConfigServiceBase.addQueryString(logoutUrl, {
          'client_id': ConfigServiceBase.clientId,
          'redirect_uri': ConfigServiceBase.defaultRedirectUrl,
          'state':  $sessionStorage.stateRequest,
          'scope': 'OSEB_SM',
          'login_hint':'username_password_sms_otp',
          'response_type': 'token'
        });
        ConfigServiceBase.authDebug = true;
        return ConfigServiceBase;
      }
    };
  }
}());
/*
* http://localhost:59468/OAuth/Authorize?client_id=7890ab
* &redirect_uri=http%3A%2F%2Flocalhost%3A38515%2FHome%2FSignIn&state=my-nonce&scope=bio%20notes&login_hint=ct_mtoken&response_type=token
* */
